import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActions = ({ 
  selectedTemplates = [], 
  onSelectAll, 
  onDeselectAll, 
  onBulkDelete, 
  onBulkExport,
  onBulkDuplicate,
  totalTemplates = 0,
  className = '' 
}) => {
  const [showActions, setShowActions] = useState(false);

  const isAllSelected = selectedTemplates?.length === totalTemplates && totalTemplates > 0;
  const isPartialSelected = selectedTemplates?.length > 0 && selectedTemplates?.length < totalTemplates;

  const handleSelectToggle = () => {
    if (isAllSelected) {
      onDeselectAll();
    } else {
      onSelectAll();
    }
  };

  if (selectedTemplates?.length === 0) {
    return null;
  }

  return (
    <div className={`bg-primary text-primary-foreground rounded-lg p-4 shadow-card ${className}`}>
      <div className="flex items-center justify-between">
        {/* Selection Info */}
        <div className="flex items-center space-x-4">
          <button
            onClick={handleSelectToggle}
            className="flex items-center space-x-2 hover:opacity-80 transition-micro"
          >
            <div className="relative">
              <div className="w-5 h-5 border-2 border-primary-foreground rounded flex items-center justify-center">
                {isAllSelected && <Icon name="Check" size={12} />}
                {isPartialSelected && <Icon name="Minus" size={12} />}
              </div>
            </div>
            <span className="font-medium">
              {selectedTemplates?.length} of {totalTemplates} selected
            </span>
          </button>
        </div>

        {/* Actions */}
        <div className="flex items-center space-x-2">
          {/* Mobile Actions Menu */}
          <div className="lg:hidden relative">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setShowActions(!showActions)}
              className="text-primary-foreground hover:bg-primary-foreground hover:bg-opacity-20"
            >
              <Icon name="MoreVertical" size={20} />
            </Button>

            {showActions && (
              <div className="absolute top-full right-0 mt-2 w-48 bg-surface border border-border rounded-lg shadow-modal z-300">
                <div className="py-2">
                  <button
                    onClick={() => {
                      onBulkDuplicate(selectedTemplates);
                      setShowActions(false);
                    }}
                    className="w-full flex items-center space-x-3 px-4 py-2 text-left hover:bg-muted transition-micro text-text-secondary"
                  >
                    <Icon name="Copy" size={16} />
                    <span>Duplicate Selected</span>
                  </button>
                  <button
                    onClick={() => {
                      onBulkExport(selectedTemplates);
                      setShowActions(false);
                    }}
                    className="w-full flex items-center space-x-3 px-4 py-2 text-left hover:bg-muted transition-micro text-text-secondary"
                  >
                    <Icon name="Download" size={16} />
                    <span>Export Selected</span>
                  </button>
                  <div className="border-t border-border my-1"></div>
                  <button
                    onClick={() => {
                      onBulkDelete(selectedTemplates);
                      setShowActions(false);
                    }}
                    className="w-full flex items-center space-x-3 px-4 py-2 text-left hover:bg-muted transition-micro text-error"
                  >
                    <Icon name="Trash2" size={16} />
                    <span>Delete Selected</span>
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Desktop Actions */}
          <div className="hidden lg:flex items-center space-x-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onBulkDuplicate(selectedTemplates)}
              iconName="Copy"
              iconPosition="left"
              className="text-primary-foreground hover:bg-primary-foreground hover:bg-opacity-20"
            >
              Duplicate ({selectedTemplates?.length})
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onBulkExport(selectedTemplates)}
              iconName="Download"
              iconPosition="left"
              className="text-primary-foreground hover:bg-primary-foreground hover:bg-opacity-20"
            >
              Export
            </Button>
            <div className="w-px h-6 bg-primary-foreground opacity-30"></div>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onBulkDelete(selectedTemplates)}
              iconName="Trash2"
              iconPosition="left"
              className="text-primary-foreground hover:bg-error hover:text-error-foreground"
            >
              Delete
            </Button>
          </div>

          {/* Close Button */}
          <Button
            variant="ghost"
            size="icon"
            onClick={onDeselectAll}
            className="text-primary-foreground hover:bg-primary-foreground hover:bg-opacity-20"
          >
            <Icon name="X" size={20} />
          </Button>
        </div>
      </div>
      {/* Quick Actions Bar */}
      <div className="mt-3 pt-3 border-t border-primary-foreground border-opacity-30">
        <div className="flex items-center justify-between text-sm">
          <span className="opacity-80">
            Quick actions for selected templates
          </span>
          <div className="flex items-center space-x-4">
            <button
              onClick={() => onBulkExport(selectedTemplates)}
              className="flex items-center space-x-1 hover:opacity-80 transition-micro"
            >
              <Icon name="Share" size={14} />
              <span>Share</span>
            </button>
            <button
              onClick={() => onBulkDuplicate(selectedTemplates)}
              className="flex items-center space-x-1 hover:opacity-80 transition-micro"
            >
              <Icon name="FolderPlus" size={14} />
              <span>Move to Folder</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkActions;